<template>
  <LoginGate @authenticated="handleAuthenticated" />
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import LoginGate from '../components/LoginGate.vue'
import { roleHomePath } from '../router'

const route = useRoute()
const router = useRouter()

function handleAuthenticated(user) {
  const next = typeof route.query.next === 'string' ? route.query.next : ''
  if (isSafeInternalPath(next) && routeAllowsRole(next, user.role)) {
    router.replace(next)
    return
  }
  router.replace(roleHomePath(user.role))
}

function routeAllowsRole(path, role) {
  const resolved = router.resolve(path)
  const roles = resolved.meta.roles
  return !Array.isArray(roles) || roles.includes(role)
}

function isSafeInternalPath(path) {
  return path.startsWith('/') && !path.startsWith('//')
}
</script>
